import { Component } from '@angular/core';
import { CaseServiceReason } from '../../cases/_types/case-service-reason';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesServicesReasonsService } from '../../cases/_services/cases-services-reasons.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-cases-services-reasons-list',
    templateUrl: './cases-services-reasons-list.component.html',
    styleUrls: ['./cases-services-reasons-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesServicesReasonsListComponent {

  public casesServicesReasons: CaseServiceReason[] = [];
  public caseServiceReasonTypes: any[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    caseServiceReasonType: new Filter(FilterOperation.equals, 'caseServiceReasonType')
  };

  public typeOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true },
    { filter: this.filters.caseServiceReasonType, type: 'select', label: 'Tipo', options: this.typeOptions, base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public casesServicesReasonsService: CasesServicesReasonsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Motivos de cancelación y citas atrasadas");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseServiceReason);
    });
    this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE")
    this.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE")
    this.loadCaseServiceReasonTypes();
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesServicesReasonsService.all(params));
    this.casesServicesReasons = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  loadCaseServiceReasonTypes() {
    this.caseServiceReasonTypes = this.casesServicesReasonsService.caseServiceReasonTypes();
    this.typeOptions.length = 0;
    this.typeOptions.push(...this.caseServiceReasonTypes);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseServiceReason: CaseServiceReason) {
    this.router.navigate(['casesServicesReasons/' + (caseServiceReason && Object.keys(caseServiceReason).length > 0 ? caseServiceReason.id : 0)]);
  }

  delete(caseServiceReason: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el motivo?",
        header: "Eliminar motivo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesServicesReasonsService.delete(caseServiceReason.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Motivo eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
